import { mapInput, make, Number } from 'effect/Equivalence';
import { Nullable } from '../Nullable/index.js';
export * from 'effect/Equivalence';
export const defaultEquivalence = make((left, right) => 
// NaN === NaN
// 0 === -0
Object.is(left, right));
export const nullable = (equivalence) => (left, right) => {
    if (Nullable.isNonNullable(left) && Nullable.isNonNullable(right)) {
        return equivalence(left, right);
    }
    return left === right;
};
// TODO remove on new effect release
export const date_ = mapInput(Number, (x) => x.getTime());
export { date_ as Date };
//# sourceMappingURL=Equivalence.js.map